export function isKeyboardClickKey(key) {
    return key === "Space" || key === "Enter";
}
export function clamp(value, min, max) {
    value = min != null && value < min ? min : value;
    return max != null && value > max ? max : value;
}
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export function isValidNumber(value) {
    return value != null && !Number.isNaN(value);
}
export function toMaxPrecision(value, maxPrecision) {
    const scaleFactor = Math.pow(10, maxPrecision);
    return Math.round(value * scaleFactor) / scaleFactor;
}
//# sourceMappingURL=utils.js.map
